import './css/main.css';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import React from 'react';
import { createRoot } from 'react-dom/client';

import AppWrapper from './components/App/AppWrapper';
import * as serviceWorker from './serviceWorker';

defineCustomElements(window);

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<AppWrapper />);
} else {
    console.error('Unable to find root container');
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
